<template>
  <v-app>
    <v-main>
      <Suspense>
        <template #default>
          <RouterView />
        </template>
      </Suspense>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import { loginService } from "@/services/LoginServce";
import { useTokenStore } from "@/stores/token";
import { RouterView, useRouter } from "vue-router";
const token = useTokenStore();
const router = useRouter();
const interval = import.meta.env.VITE_GET_SESSION_INTERVAL;

// 定期実行
setInterval(() => {
  const path: string = router.currentRoute.value.fullPath;
  console.log("idToken");
  console.log(token.$state._idToken);
  // ログイン画面ではない時、実行
  if (!(path.includes("/login") || path === "/")) getSession();
}, interval);

const getSession = async () => {
  try {
    const userToken = await loginService.updateSession();
    if (token.$state._idToken != userToken.idToken) {
      console.log("#################トークンが更新されました。#################");
      console.log("idToken更新前：", token.$state._idToken);
      console.log("idToken更新後：", userToken.idToken);
      token.setToken(
        userToken.id,
        userToken.idToken,
        userToken.idTokenExp,
        userToken.refreshToken
      );
    }
  } catch (error: any) {
    console.log(error);
  }
};
</script>

<style>
html {
  overflow-y: auto !important;
}

h2 {
  color: #42a7f9;
}

.tcenter {
  text-align: center;
}

main {
  color: #5f5f5f;
  background-color: #fff;
  line-height: 1.5;
}
</style>
